module.exports = __webpack_public_path__ + "static/media/5.6703b155.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/galeria/5.jpeg
// module id = 158
// module chunks = 0